import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @Input() message: string = 'Loading...';

  /** Smaller spinner + text (e.g. tab panels, inline panels) */
  @Input() compact = false;

  constructor() { }

  ngOnInit(): void {
  }

}
